import './css/App.css';
import {useContext} from 'react'
import {Navigate, Route, Routes} from "react-router-dom";
import {AppContext} from "./componnents/context/AppContext";
import {AddAssetProvider} from "./componnents/context/AddAssetContext";
import Login from './componnents/Login';
import AddAsset from './componnents/addAsset/AddAsset';
import ViewEditAsset from './componnents/viewEditAsset/ViewEditAsset';
import {ViewEditAssetProvider} from './componnents/context/ViewEditAssetContext';
import {ReplaceTrackerProvider} from './componnents/context/ReplaceTrackerContext';
import ReplaceTracker from './componnents/replaceTracker/ReplaceTracker';
import ReplaceBatteries from './componnents/replaceBatteries/ReplaceBatteries';
import BulkLoadAsset from './componnents/bulkLoadAsset/BulkLoadAsset';
import AddUpdateLocation from './componnents/addUpdateLocation/AddUpdateLocation';
import {AddUpdateLocationProvider} from './componnents/context/AddUpdateLocationContext';
import SingleTracker from "./componnents/singleTracker/SingleTracker";
import {VersionCheck} from "react-version-check";
import packageJson from '../package.json';

function App() {
    const {login} = useContext(AppContext);
    const [isLogged] = login;
    // useEffect(() => {

    // if(isLogged === false){
    //   console.log(`token-validate token : ${auth.token}`);

    //   axios.get("token-validate",{ 
    //     headers: {
    //       Authorization: `Basic ${auth.token}`,
    //       // type: "cookie"
    //     }}).then((res) =>{
    //       if(res.status === 200){
    //         setIsLogged(true)
    //       }
    //     })
    // }
    // },[])
    return (
        <div className="App">
            <VersionCheck currentVersion={packageJson.version} side="right" dependencies={[isLogged]} />
            {isLogged ?
                (<>
                    <Routes>
                        <Route path="/" element={<Navigate to={'/registration-single-tracker'}/>}/>
                        <Route path="/registration-single-tracker" element={
                            <SingleTracker/>
                        }/>
                        <Route path="/bulk-registration" element={
                            <BulkLoadAsset
                                title="Trackers Bulk Registration"
                                fileName="RegistrationBulkLoadExample.csv"
                                btnText="Register"
                                requestType="trackerBulkRegistration"
                                successesText="tracker(s) successfully registered"
                                failText="tracker(s) failed to register"
                                tooltipText="Upload a comma separated CSV file with list of trackers to register. Use sample file as template"
                            />
                        }/>

                        <Route path="/single-tracker-activation" element={
                            <AddAssetProvider>
                                <AddAsset/>
                            </AddAssetProvider>
                        }/>
                        <Route path="/view-edit-asset" element={
                            <ViewEditAssetProvider>
                                <ViewEditAsset/>
                            </ViewEditAssetProvider>
                        }/>
                        {/*<Route  path="/load-sensor" element={*/}
                        {/*  <AddLoadSensorProvider>*/}
                        {/*    <AddLoadSensor/>*/}
                        {/*  </AddLoadSensorProvider>*/}
                        {/*}/>*/}
                        <Route path="/replace-tracker" element={
                            <ReplaceTrackerProvider>
                                <ReplaceTracker/>
                            </ReplaceTrackerProvider>
                        }/>
                        <Route path="/replace-batteries" element={
                            <ReplaceBatteries/>
                        }/>
                        <Route path="/bulk-activation" element={
                            <BulkLoadAsset
                                title="Trackers Bulk Activation"
                                fileName="BulkLoadExample.csv"
                                btnText="Activate"
                                requestType="assetsBulkLoad"
                                successesText="tracker(s) successfully activated"
                                failText="tracker(s) failed to activate"
                                tooltipText="Upload a comma separated CSV file with list of assets to associate. Use sample file as template"
                            />
                        }/>
                        <Route path="/load-polygons" element={
                            <AddUpdateLocationProvider>
                                <AddUpdateLocation/>
                            </AddUpdateLocationProvider>
                        }/>
                    </Routes>
                </>)
                :
                (<>
                    <Routes>
                        <Route path="/" element={<Login/>}/>
                        <Route path="/*" element={<Navigate to={'/'}/>}/>
                    </Routes>
                </>)
            }
        </div>
    );
}

export default App;
